var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBUserCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-user-cancel",
    x: 0,
    y: 0,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,16.741c-3.706,0.005 -7.13,1.984 -8.985,5.194c-0.166,0.322 -0.502,0.541 -0.889,0.541c-0.552,0 -1,-0.448 -1,-1c-0,-0.199 0.058,-0.385 0.159,-0.541c1.484,-2.569 3.81,-4.476 6.516,-5.455c-2.061,-1.365 -3.422,-3.704 -3.422,-6.359c0,-4.206 3.415,-7.621 7.621,-7.621c4.206,0 7.621,3.415 7.621,7.621c-0,2.651 -1.356,4.987 -3.412,6.352c2.713,0.977 5.047,2.887 6.534,5.462l-0.004,0.002c0.1,0.156 0.158,0.341 0.158,0.539c-0,0.552 -0.448,1 -1,1c-0.402,0 -0.749,-0.237 -0.908,-0.58c-1.862,-3.191 -5.279,-5.155 -8.975,-5.155l-0.014,0Zm0.014,-1.999c3.096,-0.008 5.607,-2.523 5.607,-5.621c-0,-3.102 -2.519,-5.621 -5.621,-5.621c-3.102,-0 -5.621,2.519 -5.621,5.621c0,3.102 2.519,5.621 5.621,5.621l0.014,-0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.61,11.992l-8.509,-8.509c-0.384,-0.384 -0.384,-1.007 -0,-1.391c0.383,-0.383 1.006,-0.383 1.39,0l8.509,8.509l8.509,-8.509c0.384,-0.383 1.007,-0.383 1.39,0c0.384,0.384 0.384,1.007 0,1.391l-8.509,8.509l8.509,8.509c0.384,0.384 0.384,1.007 0,1.39c-0.383,0.384 -1.006,0.384 -1.39,0l-8.509,-8.509l-8.509,8.509c-0.384,0.384 -1.007,0.384 -1.39,0c-0.384,-0.383 -0.384,-1.006 -0,-1.39l8.509,-8.509Z",
    style: {
      fill: "#d4372b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBUserCancel);
export default __webpack_public_path__ + "static/media/iconB-user-cancel.a26c43d88bbb738ce0e36a504016af09.svg";
export { ForwardRef as ReactComponent };